import { get, post, put } from '../utils/http';


/**
 * 邮寄材料任务详情
 * @param {*} params
 * flowId
 */
export function getExpressMaterialInfo(params) {
  return get('/api/lossAss/expressMaterial', params);
}

/**
 * 邮寄材料.包裹列表
 * @param {*} expressType receive 收到包裹; post 寄出包裹
 * @param {*} params
 * flowId
 */
export function getExpressPackageList(expressType, params) {
  return get(`/api/lossAss/expressMaterial/package/${expressType}`, params);
}

/**
 * 发起邮寄材料任务
 * flowId
 * @param {*} params
 * content
 */
export function createExpressMaterialTask(flowId, params) {
  return post(`/api/lossAss/expressMaterial?flowId=${flowId}`, params);
}

/**
 * 邮寄材料初审通过
 * @param {*} flowId
 * @param {*} params
 * content
 */
export function approveExpressMaterialCheck(flowId, params) {
  return put(`/api/lossAss/expressMaterial/checked?flowId=${flowId}`, params);
}

/**
 * 邮寄材料
 * @param {*} flowId
 * @param {*} params
 * content
 * postedDate
 * expressCompany
 * expressNumber
 * remark
 */
export function finishExpressMaterial(flowId, params) {
  return put(`/api/lossAss/expressMaterial/finished?flowId=${flowId}`, params);
}


/**
 * 添加寄出/收到包裹
 * @param {*} expressType receive 收到包裹; post 寄出包裹
 * @param {} flowId
 * @param {*} params
 * postedDate
 * expressCompany
 * expressNumber
 * remark
 */
export function addExpressPackage(expressType, flowId, params) {
  return post(`/api/lossAss/expressMaterial/package/${expressType}?flowId=${flowId}`, params);
}

/**
 * 邮寄材料任务.不合格
 * @param {*} flowId
 * @param {*} params
 * content
 * reason
 */
export function returnExpressMaterialCheck(flowId, params) {
  return put(`/api/lossAss/expressMaterial/returned?flowId=${flowId}`, params);
}

/**
 * 沟通客户，补充邮寄材料
 * @param {*} flowId
 * @param {*} params
 * content
 * remark
 * nextDate
 */
export function addExpressMaterialTask(flowId, params) {
  return put(`/api/lossAss/expressMaterial/added?flowId=${flowId}`, params);
}

/**
 * 邮寄材料.统计数据
 */
export function expressMaterialStat() {
  return get(`/api/lossAss/expressMaterial/stat`);
}
/**
 * 获取寄出邮寄包裹文件示例
 */
export function getTemplateByImportExpress() {
  return get('/api/lossAss/expressMaterial/import/excel');
}
/**
 * 导入邮寄包裹
 * @param {*} params 
 * file
 */
export function importExpressFile(params) {
  return post('/api/lossAss/expressMaterial/import/check', params)
}
/**
 * 获取邮寄包裹导入状态
 */
export function getImportingExpressStatus() {
  return get('/api/lossAss/expressMaterial/import/status');
}